import script from "./DesktopView.vue?vue&type=script&setup=true&lang=js"
export * from "./DesktopView.vue?vue&type=script&setup=true&lang=js"

import "./DesktopView.vue?vue&type=style&index=0&id=61551ab0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61551ab0"]])

export default __exports__